export default __webpack_public_path__ + "static/media/recommended_detail_arrow.092e2ab3.svg";